import {
  Grid,
  TextField,
  FormControl,
  Typography
} from '@mui/material';
import { forwardRef } from 'react';
import { DatePicker, PickersDay } from '@mui/lab';

interface DatePickerProps {
  label?: string;
  title?: string;
  value: Date | null,
  disable?: boolean,
  minDate?: Date | null,
  maxDate?: Date | null,
  onChange: (e: any) => void,
  fullWidth: boolean | null,
  mt?: number | null,
  views?: any | null,
  inputFormat?: string | null,
  disabled?: boolean,
  required?: boolean,
  className?: string
}

const SingleDatePicker = forwardRef((props: DatePickerProps, _ref) => {
  
  const getDate = (date) => {
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
  }

  return (
    <FormControl className={`date-filter ${props.className || ''}`} fullWidth={props?.fullWidth}
      disabled={props?.disabled ? props?.disabled : false}>
      {props?.title && 
        <Typography fontWeight="light" variant="h5" className='input-lable'>
          {props?.title}{props?.required && <span style={{ color: 'red' }}>*</span>}
        </Typography>
      }
      <Grid sx={{ mt: props.mt ? props?.mt : '4px' }} position='relative'>
        <DatePicker
          views={props?.views && props?.views}
          inputFormat={props?.inputFormat ? props?.inputFormat : "yyyy-MM-dd"}
          disabled={props?.disabled}
          label={props?.label}
          InputProps={{
            className: 'date-picker',
          }}
          minDate={props?.minDate && getDate(props?.minDate)}
          maxDate={props?.maxDate && getDate(props?.maxDate)}
          renderInput={(params) => (
            <TextField {...params} id="date" 
              inputProps={{...params.inputProps, readOnly: true}}
            />
          )}
          renderDay={(day, _value, DayComponentProps) => {
            return (
              <PickersDay {...DayComponentProps}/>
            )
          }}
          value={props?.value}
          onChange={(newValue) => {
            if (newValue) {
              props?.onChange(newValue);
            }
          }}
        />
      </Grid>
    </FormControl>
    
  );
});

export default SingleDatePicker;
